// extracted by mini-css-extract-plugin
export default {"agreementArea":"AgreementReviewModal_agreementArea__9hA6q"};